import { useState, useEffect } from "react";
import useApi from "./Api";

export const useGet = (url, initialState) => {
  const Api = useApi();

  const getData = async (url, initialState) => {
    try {
      const res = await Api.get(url);
      var result;
      if (res?.data) {
        result = res?.data;
      } else {
        result = res?.response;
      }
      return result;
    } catch (error) {
      console.log(error);
      return initialState;
    }
  };
  return getData;
};
export const useGetApi = (path, initialState, immediate = true) => {
  const [isLoading, setLoading] = useState(false);
  const Api = useApi();
  const [response, setResponse] = useState(initialState);
  const [errorMsg, setErrorMsg] = useState("");

  const getData = async (url) => {
    try {
      const res = await Api.get(url);
      console.log("api res 36", res);
      var result = initialState;
      if (res) {
        result = res;
      } else {
        result = res;
      }
      setResponse(result);
      setErrorMsg("");
      return result;
    } catch (error) {
      console.log(error);
      setErrorMsg(error.message);
      return initialState;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (immediate) {
      getData(path);
    }
  }, []);

  return [errorMsg, isLoading, response, getData, setResponse];
};

export default useGetApi;
